/* tslint:disable */
/* eslint-disable */
/**
 * cellera-backend API spec
 * Backend Service for Cellera | [swagger.json](cellera/swagger.json)
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { PatientDto } from './PatientDto';
import {
    PatientDtoFromJSON,
    PatientDtoFromJSONTyped,
    PatientDtoToJSON,
    PatientDtoToJSONTyped,
} from './PatientDto';

/**
 * 
 * @export
 * @interface GetPatientForProviderByIdResponseDto
 */
export interface GetPatientForProviderByIdResponseDto {
    /**
     * information patient
     * @type {PatientDto}
     * @memberof GetPatientForProviderByIdResponseDto
     */
    patient: PatientDto;
    /**
     * has requested successfully before
     * @type {boolean}
     * @memberof GetPatientForProviderByIdResponseDto
     */
    hasRequestedSuccessfullyBefore: boolean;
}

/**
 * Check if a given object implements the GetPatientForProviderByIdResponseDto interface.
 */
export function instanceOfGetPatientForProviderByIdResponseDto(value: object): value is GetPatientForProviderByIdResponseDto {
    if (!('patient' in value) || value['patient'] === undefined) return false;
    if (!('hasRequestedSuccessfullyBefore' in value) || value['hasRequestedSuccessfullyBefore'] === undefined) return false;
    return true;
}

export function GetPatientForProviderByIdResponseDtoFromJSON(json: any): GetPatientForProviderByIdResponseDto {
    return GetPatientForProviderByIdResponseDtoFromJSONTyped(json, false);
}

export function GetPatientForProviderByIdResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPatientForProviderByIdResponseDto {
    if (json == null) {
        return json;
    }
    return {
        
        'patient': PatientDtoFromJSON(json['patient']),
        'hasRequestedSuccessfullyBefore': json['hasRequestedSuccessfullyBefore'],
    };
}

export function GetPatientForProviderByIdResponseDtoToJSON(json: any): GetPatientForProviderByIdResponseDto {
    return GetPatientForProviderByIdResponseDtoToJSONTyped(json, false);
}

export function GetPatientForProviderByIdResponseDtoToJSONTyped(value?: GetPatientForProviderByIdResponseDto | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'patient': PatientDtoToJSON(value['patient']),
        'hasRequestedSuccessfullyBefore': value['hasRequestedSuccessfullyBefore'],
    };
}

